import { ContractListTypeEnum, GetCoinListTypeEnum } from '@/enums/businessEnum';
import CacheEnum from '@/enums/cacheEnum';
import { useModel } from '@umijs/max';
import { useMemo } from 'react';
import ProjectSetting from '@/setting/projectSetting';
import useCoinMarket from '../hooks/useCoinMarket';

export default () => {
  // 获取用户信息
  const { user } = useModel('user');
  // 普通合约币种和列表
  const {
    localCoin: localContract,
    setLocalCoin: setLocalContract,
    localList: contractList,
    loading: contractLoading,
    getList: getContractList,
    updateLocal: updateLocalContract,
    onContractCoinClick,
  } = useCoinMarket({
    localCacheKey: CacheEnum.APP_LOCAL_CONTRACT,
    localListCacheKey: CacheEnum.PAGE_HOME_CONTRACT_LIST,
    type: GetCoinListTypeEnum.CONTRACT,
    disable:ProjectSetting.isOpenCommContract
  });
  // 极速合约币种和列表
  const {
    localCoin: localFastContract,
    setLocalCoin: setLocalFastContract,
    localList: fastContractList,
    loading: fastLoading,
    getList: getFastContractList,
    updateLocal: updateFastLocalContract,
    onContractCoinClick: onFastContractCoinClick,
  } = useCoinMarket({
    localCacheKey: CacheEnum.APP_FASTCONTRACT,
    localListCacheKey: CacheEnum.PAGE_HOME_FAST_CONTRACT_LIST,
    type: GetCoinListTypeEnum.FASTCONTRACT,
    disable:ProjectSetting.isOpenSpeedContract
  });
  // 外汇合约币种和列表
  const {
    localCoin: localForexContract,
    setLocalCoin: setLocalForexContract,
    localList: forexContractList,
    loading: forexLoading,
    updateLocal: updateForexLocalContract,
    onContractCoinClick: onForexContractCoinClick,
  } = useCoinMarket({
    localCacheKey: CacheEnum.APP_FOREX_CONTRACT,
    localListCacheKey: CacheEnum.PAGE_HOME_FOREX_CONTRACT,
    type: GetCoinListTypeEnum.CONTRACT,
    contractType: ContractListTypeEnum.FOREIGN_EXCHANGE,
    disable:!ProjectSetting.isOpenForexContract
  });
  // 期货
  const {
    localCoin: localFuturesContract,
    setLocalCoin: setLocalFuturesContract,
    localList: futuresContractList,
    loading: futuresLoading,
    updateLocal: updateFuturesLocalContract,
    onContractCoinClick: onFuturesContractCoinClick,
  } = useCoinMarket({
    localCacheKey: CacheEnum.APP_FUTURES_CONTRACT,
    localListCacheKey: CacheEnum.PAGE_HOME_FUTURES_CONTRACT_LIST,
    type: GetCoinListTypeEnum.CONTRACT_FUTURES,
    disable:ProjectSetting.isOpenSpeedFutures
  });


  const updateContract = async (symbol: any, type = ProjectSetting.APP_DEFAULT_CONTRACT_TYPE) => {
    if (symbol && user?.id && type) {
      if (type === GetCoinListTypeEnum.CONTRACT) {
        updateLocalContract(symbol);
      } else if (type === GetCoinListTypeEnum.FASTCONTRACT) {
        updateFastLocalContract(symbol);
      } else if (type === GetCoinListTypeEnum.FOREIGN_EXCHANGE) {
        updateForexLocalContract(symbol);
      } else if (type === GetCoinListTypeEnum.CONTRACT_FUTURES) {
        updateFuturesLocalContract(symbol);
      }
    }
  };

  // 小数长度，后台设置的精度
  const priceAccuracy = useMemo(() => {
    return localContract?.priceAccuracy ?? 6;
  }, [localContract]);

  const transactionAccuracy = useMemo(() => {
    return localContract?.transactionAccuracy ?? 4;
  }, [localContract]);

  return {
    localContract,
    setLocalContract,
    contractList,
    fastContractList,
    getFastContractList,
    localFastContract,
    setLocalFastContract,
    getContractList,
    contractListLoading: contractLoading,
    updateContract,
    priceAccuracy,
    transactionAccuracy,
    contractLoading,
    fastLoading,
    forexLoading,
    forexContractList,
    setLocalForexContract,
    localForexContract,
    localFuturesContract,
    setLocalFuturesContract,
    futuresContractList,
    futuresLoading,
    onContractCoinClick,
    onFastContractCoinClick,
    onForexContractCoinClick,
    onFuturesContractCoinClick,
  };
};
